import Swal from 'sweetalert2';
import { confirmedValue, editHtml, openPeriodHtml, periodDate, periodScore, readEditInput, readOpenInput, readReopenInput, reopenHtml } from './period-dialog-helpers';

export async function confirmDialog(
  title: string,
  html: string,
  confirmText: string,
): Promise<boolean> {
  const result = await Swal.fire({
    title,
    html,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: confirmText,
    cancelButtonText: 'Cancelar',
  });
  return result.isConfirmed;
}

export async function promptOpenPeriod(monthLabel: string): Promise<{ expirationDate: string } | null> {
  const result: any = await Swal.fire({
    title: 'Abrir periodo',
    html: openPeriodHtml(monthLabel),
    showCancelButton: true,
    confirmButtonText: 'Abrir periodo',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#3085d6',
    preConfirm: readOpenInput,
  });
  return confirmedValue(result);
}

export async function promptReopenPeriod(count: number, monthLabel: string): Promise<string | null> {
  const result: any = await Swal.fire({
    title: 'Reabrir periodos',
    html: reopenHtml(count, monthLabel),
    showCancelButton: true,
    confirmButtonText: 'Reabrir',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#3085d6',
    preConfirm: readReopenInput,
  });
  return confirmedValue(result);
}

export async function promptEditPeriod(period: any): Promise<{ expiration: string; score: number } | null> {
  const result: any = await Swal.fire({
    title: 'Editar periodo',
    html: editHtml(periodDate(period), periodScore(period)),
    showCancelButton: true,
    confirmButtonText: 'Guardar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#3085d6',
    preConfirm: readEditInput,
  });
  return confirmedValue(result);
}

export function successToast(title: string): void {
  Swal.fire({ icon: 'success', title, timer: 1500, showConfirmButton: false });
}

export function errorDialog(text?: string): void {
  Swal.fire({ icon: 'error', title: 'Error', text: text || 'Ocurrió un error inesperado' });
}
